{
  "APP_NAME": "WordPress Hosting Admin",
  "NAVIGATION": {
    "TABS": {
      "PRODUCT_SETTINGS": "Product settings",
      "TEMPLATES": "Templates",
      "DASHBOARD": "Dashboard",
      "UPDATE": "Update",
      "UPTIME": "Uptime"
    },
    "FOOTER": {
      "POWERED_BY": "Powered by"
    }
  },
  "ADVANCED_PAGE": {
    "SHOW_ADVANCED_FEATURES_CARD": {
      "TITLE": "Show advanced features",
      "DESCRIPTION": "Disable this setting to hide the \"Advanced\" tab from your client users. Users in your organization will still be able to see this tab when they access a client's Website product.",
      "TOGGLE_LABEL": "Show \"Advanced\" tab from your client users",
      "SHOW_ADVANCED_FEATURES_ON": "on",
      "SHOW_ADVANCED_FEATURES_OFF": "off"
    },
    "SHOW_INCLUDED_TEMPLATES_CARD": {
      "TITLE": "Show included templates",
      "DESCRIPTION": "Disable this setting to hide the included Website templates from your clients and only show the custom templates you have created.",
      "TOGGLE_LABEL": "Show the included templates from your client users",
      "SHOW_INCLUDED_TEMPLATES_ON": "on",
      "SHOW_INCLUDED_TEMPLATES_OFF": "off"
    },
    "SHOW_DOMAINS_FEATURES_CARD": {
      "TITLE": "Show domains features",
      "DESCRIPTION": "Enable this setting to show the \"Domains\" tab from your client users. This allows them to manage custom domains for their WordPress sites.",
      "SHOW_DOMAINS_FEATURES_ON": "on",
      "SHOW_DOMAINS_FEATURES_OFF": "off"
    },
    "SHOW_IMPORT_FEATURES_CARD": {
      "TITLE": "Show import features",
      "DESCRIPTION": "Enable this setting to show the \"Import\" tab from your client users. This allows them to import content and data into their WordPress sites.",
      "SHOW_IMPORT_FEATURES_ON": "on",
      "SHOW_IMPORT_FEATURES_OFF": "off"
    },
    "SHOW_BACKUPS_FEATURES_CARD": {
      "TITLE": "Show backups features",
      "DESCRIPTION": "Enable this setting to show the \"Backups\" tab from your client users. This allows them to manage automated backups for their WordPress sites.",
      "SHOW_BACKUPS_FEATURES_ON": "on",
      "SHOW_BACKUPS_FEATURES_OFF": "off"
    },
    "SHOW_STAGING_FEATURES_CARD": {
      "TITLE": "Show staging features",
      "DESCRIPTION": "Enable this setting to show the \"Staging\" tab from your client users. This allows them to create staging environments for testing changes before deploying to production.",
      "SHOW_STAGING_FEATURES_ON": "on",
      "SHOW_STAGING_FEATURES_OFF": "off"
    }
  },
  "PAGES": {
    "PRODUCT_SETTINGS": {
      "TITLE": "Product settings"
    },
    "CREATE_FROM_TEMPLATES": {
      "TEMPLATES_MANAGE": {
        "TITLE": "Manage your custom templates",
        "SUBTITLE": "Templates allow you to save themes, plugins, and site content for use when creating a new site. Only users in your organization have access to this tab, but the templates you create will be available to anyone making a new site. Create and edit up to {{ maxTemplates }} of your own templates.",
        "DISTRIBUTED_TEMPLATES": "Distributed Templates",
        "NON_DISTRIBUTED_TEMPLATES": "Non-Distributed Templates"
      },
      "TEMPLATE_SECTIONS": {
        "ECOMMERCE": {
          "SUBTITLE_PLAINTEXT": "All of these templates come with WooCommerce and Divi Builder."
        }
      },
      "TEMPLATE_SELECTION": {
        "PREVIEW": "Preview",
        "SELECT_TEMPLATE": "Use ",
        "RESET_FROM_TEMPLATE": "Reset from ",
        "EDIT_TEMPLATE": "Edit template",
        "DELETE": "Delete",
        "CONFIRMATION": {
          "TITLE": "Use this template?",
          "BODY": "This will copy all themes, plugins, pages, and posts from this template to your new site. You will not be able to select a different template after launching your website.",
          "CONFIRM": "Confirm"
        },
        "CONFIRM_RESET_TEMPLATE": {
          "TITLE": "Are you sure you want to reset your staging site?",
          "BODY": "This cannot be undone. Changes made on your previous staging site will be lost",
          "CONFIRM": "Confirm"
        }
      }
    },
    "DELETE_TEMPLATE": {
      "CONTENT": "Are you sure you want to delete this template?",
      "ACTION": "Confirm"
    },
    "DASHBOARD": {
      "TITLE": "Dashboard",
      "SUMMARY": {
        "TITLE": "Updates available",
        "PLUGINS": "Plugins",
        "WORDPRESS": "WordPress",
        "THEME": "Theme",
        "TOTAL": "Total"
      },
      "TABLE": {
        "HEADERS": {
          "ACCOUNT": "Account",
          "URL": "URL",
          "SUBSITES_COUNT": "Subsites Count",
          "PLUGIN_UPDATES": "Plugin Updates",
          "WORDPRESS_VERSION": "WordPress Version",
          "THEME_VERSION": "Theme Version",
          "PHP_VERSION": "PHP Version",
          "LINKS": "Links"
        },
        "NO_DATA_TOOLTIP": "We couldn't grab this data. This is usually caused by your site's firewall, a security plugin, or a temporary loss of access.",
        "PHP_SORT_TOOLTIP": "Click to sort PHP versions on the current page. To sort across all your sites, increase the page size (up to 500).",
        "NOT_MULTISITE_TOOLTIP": "There are no subsites detected because this account is a single site account.",
        "MULTISITE_BADGE": "Premium",
        "WSP_DASHBOARD": "WordPress Hosting Dashboard",
        "WP_DASHBOARD": "WordPress Dashboard"
      },
      "MS_REPORT_TABLE": {
        "TITLE": "Vendasta Services Website Vulnerability Report"
      }
    },
    "UPTIME": {
      "TITLE": "Uptime",
      "ALL_WEBSITES": "All Websites",
      "SITES_UP": "Sites Up",
      "SITES_DOWN": "Sites Down",
      "SITES_PAUSED": "Sites Paused",
      "UP": "Up",
      "DOWN": "Down",
      "PAUSED": "Paused",
      "TOOLTIP": "Uptime checks are performed every 30 minutes",
      "TABLE": {
        "HEADERS": {
          "STATUS": "Status",
          "24HOURS": "24 Hours",
          "7DAYS": "7 Days",
          "30DAYS": "30 Days"
        },
        "WSP_DASHBOARD": "WordPress Hosting Dashboard",
        "WP_DASHBOARD": "WordPress Dashboard"
      },
      "A_RECORD": "A Record",
      "DOMAIN_NOT_ASSOCIATED_DESCRIPTION": "This site is using a custom domain that is not reachable from Vendasta hosting. Uptime monitoring is based on the configured domain URL, so alerts may appear if the site is hosted externally or the URL is no longer valid. To avoid confusion, manage this domain from the Domains page by removing the custom domain or updating the URL.",
      "HTTPERRORSTEPS": {
        "400": {
          "ERROR_NAME": "Bad Request",
          "DESCRIPTION": "The server could not understand the request due to invalid syntax.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Check the URL for any typos or malformed syntax.",
            "STEP2": "Clear your browser cache and cookies.",
            "STEP3": "Disable any WordPress plugins that might interfere with requests.",
            "STEP4": "Ensure the NGINX configuration does not block specific requests.",
            "STEP5": "If using a CDN, ensure it is properly configured."
          }
        },
        "401": {
          "ERROR_NAME": "Unauthorized",
          "DESCRIPTION": "Authentication is required and has failed or not been provided.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Ensure the correct username and password are being used.",
            "STEP2": "Verify the site's authentication headers or tokens are correctly configured.",
            "STEP3": "Disable or troubleshoot WordPress security plugins blocking access.",
            "STEP4": "Check the server logs for more detailed error messages.",
            "STEP5": "Ensure file permissions are set correctly (e.g., wp-admin should be accessible)."
          }
        },
        "403": {
          "ERROR_NAME": "Forbidden",
          "DESCRIPTION": "You do not have permission to access the requested resource.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Check file and directory permissions (recommended: 755 for directories and 644 for files).",
            "STEP2": "Disable WordPress security plugins temporarily to test for conflicts.",
            "STEP3": "Verify the NGINX configuration for any restrictive rules.",
            "STEP4": "Ensure your IP or country is not blocked by server-level rules.",
            "STEP5": "Contact the hosting provider to check server-side configurations."
          }
        },
        "404": {
          "ERROR_NAME": "Not Found",
          "DESCRIPTION": "The server cannot find the requested resource.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Ensure the URL is correct and points to an existing page.",
            "STEP2": "Check WordPress permalink settings under Settings > Permalinks and re-save them.",
            "STEP3": "Ensure NGINX is configured to pass requests correctly to the WordPress index.php file.",
            "STEP4": "Clear the site cache and browser cache.",
            "STEP5": "Restore missing files or content if they were accidentally deleted."
          }
        },
        "500": {
          "ERROR_NAME": "Internal Server Error",
          "DESCRIPTION": "The server encountered an internal error and could not complete your request.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Check the server error logs for specific issues.",
            "STEP2": "Disable all WordPress plugins and switch to a default theme to test for conflicts.",
            "STEP3": "Verify the NGINX configuration for any incorrect directives.",
            "STEP4": "Ensure your hosting environment meets the WordPress requirements (e.g., PHP version)."
          }
        },
        "502": {
          "ERROR_NAME": "Bad Gateway",
          "DESCRIPTION": "The server received an invalid response from the upstream server.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Restart your web server or contact your hosting provider to resolve upstream issues.",
            "STEP2": "Disable proxy services like Cloudflare temporarily to test direct server access.",
            "STEP3": "Check for server overload or high traffic and upgrade hosting if necessary.",
            "STEP4": "Ensure your WordPress site is not hitting PHP-FPM or FastCGI limits.",
            "STEP5": "Verify DNS settings to ensure the domain resolves to the correct server."
          }
        },
        "503": {
          "ERROR_NAME": "Service Unavailable",
          "DESCRIPTION": "The server is temporarily unable to handle the request.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Check for ongoing maintenance mode in WordPress (remove .maintenance file if present).",
            "STEP2": "Disable all plugins to test for performance-related issues.",
            "STEP3": "Upgrade your hosting plan if the site exceeds server resource limits.",
            "STEP4": "Contact your hosting provider to investigate server overload.",
            "STEP5": "Ensure cron jobs are not causing excessive server load."
          }
        },
        "504": {
          "ERROR_NAME": "Gateway Timeout",
          "DESCRIPTION": "The server took too long to respond to the request.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Increase the server timeout limits in php.ini or NGINX configuration.",
            "STEP2": "Optimize your WordPress database to improve query performance.",
            "STEP3": "Disable plugins causing high server load (e.g., poorly optimized caching plugins).",
            "STEP4": "Check DNS settings and ensure the server resolves correctly.",
            "STEP5": "Upgrade to a more powerful hosting plan if necessary."
          }
        },
        "526": {
          "ERROR_NAME": "Invalid SSL Certificate",
          "DESCRIPTION": "The SSL certificate used is invalid.",
          "STEPS_TO_RESOLVE": {
            "STEP1": "Reinstall the SSL certificate through your hosting provider's dashboard.",
            "STEP2": "Check the certificate's expiration date and renew it if expired.",
            "STEP3": "Ensure the server is configured to use the correct SSL certificate.",
            "STEP4": "Use an SSL checker tool to validate the certificate's chain and configuration.",
            "STEP5": "Contact your hosting provider to regenerate the SSL certificate."
          }
        }
      }
    },
    "NOHTTPDATA": {
      "NO_DESCRIPTION": "No description available.",
      "NO_STEPS": "No steps available."
    },
    "NOERRORCODEDATA": {
      "NO_DATA_DESCRIPTION": "No description available for this error code.",
      "NO_DATA_STEPS": "No resolution steps available for this error code. Please contact the support."
    },
    "HTTPERROR": {
      "404": "Not found",
      "403": "Forbidden",
      "500": "Internal Server Error",
      "502": "Bad Gateway",
      "301": "Moved Permanently",
      "429": "Too Many Requests",
      "521": "Web Server Is Down",
      "526": "Invalid SSL Certificate",
      "530": "Origin DNS Error",
      "525": "SSL Handshake Failed",
      "400": "Bad Request",
      "504": "Gateway Timeout",
      "410": "Gone",
      "436": "Blocked by Wordfence",
      "406": "Not Acceptable",
      "520": "Web Server Is Returning an Unknown Error",
      "401": "Unauthorized",
      "409": "Conflict",
      "302": "Temporarily Moved",
      "308": "Permanent Redirect",
      "303": "See Other",
      "523": "Origin Is Unreachable",
      "405": "Method Not Allowed",
      "307": "Temporary Redirect",
      "408": "Request Timeout",
      "508": "Loop Detected",
      "415": "Unsupported Media Type",
      "423": "Locked"
    }
  },
  "APP_FAILURE": {
    "TITLE": "Something's gone wrong, but we're working on it.",
    "SITE_ERROR": "Try accessing this page again in a few minutes.",
    "DEFAULT": "We're terribly sorry, something went wrong."
  },
  "APP_INSUFFICIENT_PERMISSION": {
    "TITLE": "You don't have permission to view this page.",
    "SITE_ERROR": "Sign in as a different user to continue.",
    "SIGN_IN": "Sign in"
  },
  "BUTTONS": {
    "CANCEL": "Cancel",
    "CLOSE": "Close"
  },
  "ALERTS": {
    "GENERAL": {
      "DISMISS": "Dismiss"
    }
  },
  "API_ERROR": {
    "DomainConflictException": "Sorry, the following domains are already taken: {{ data.conflictingDomains }}",
    "InvalidDomainException": "Sorry, but {{ data.domain }} doesn't seem to belong to your site.",
    "InvalidValueException": "Sorry, that is not a valid value.",
    "InvalidValueSubDomainException": "Sorry, but your sub-domain seems to be invalid.",
    "InvalidValueSubtitleException": "Sorry, but your subtitle seems to be invalid.",
    "InvalidValueTitleException": "Sorry, but your title seems to be invalid.",
    "InvalidRequestForDomainStateException": "Sorry, but {{ data.domain }} is in a {{ data.state }} state.",
    "InvalidRequestForPrimaryDomainException": "Sorry, but {{ data.domain }} is currently your primary domain.",
    "MaxNumberDomainsException": "Sorry, but you've reached your limit with {{ data.maxNumber }} domains.",
    "ServiceNotFoundException": "Service not available. Please try again later.",
    "SiteLockedException": "Sorry, the site is busy right now. Please try again later.",
    "SiteNotFoundException": "This is embarrassing; we're having trouble finding your site right now.",
    "SiteReservationConflictException": "Sorry, your account already has a site under construction.",
    "TemplateIsAlreadyDeletingException": "Sorry, the template is already deleted.",
    "SuspendedAPIError": "{{ data.message }}",
    "UNKNOWN": "An error occurred. Please try again."
  }
}
